import React from 'react';
import styled from 'styled-components';
import PriceDetail from './components/PriceDetail/PriceDetail';
import TotalPrice from './components/TotalPrice';
import type { PriceDetailType } from '../../types';
import { TEST_ID_MOBILE_SUMMARY_PRICE_DETAIL } from './constants';

type Props = {
  totalPrice: number;
  instantConfirm: boolean;
  cashbackAmount: number;
  packageId: number;
  priceDetailsItems: PriceDetailType[];
  cashbackIdentifier?: string;
};

const PriceSummary = (props: Props) => {
  const {
    totalPrice,
    instantConfirm,
    cashbackAmount,
    packageId,
    priceDetailsItems,
    cashbackIdentifier,
  } = props;
  return (
    <Wrapper>
      <TotalPrice
        totalPrice={totalPrice}
        instantConfirm={instantConfirm}
        cashbackAmount={cashbackAmount}
        packageId={packageId}
        cashbackIdentifier={cashbackIdentifier}
      />
      <PriceDetails>
        {priceDetailsItems.map((priceDetail, idx) => (
          <PriceDetail
            testId={`${TEST_ID_MOBILE_SUMMARY_PRICE_DETAIL}-${idx}`}
            key={priceDetail.description}
            {...priceDetail}
          />
        ))}
      </PriceDetails>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 8px;
  font-size: 14px;
`;

const PriceDetails = styled.div`
  > * + * {
    margin-top: 2px;
  }
`;

export default PriceSummary;
